import { h } from 'preact';
import SVGCreator from '../../../../common/components/svg/SVGCreator';
import { FRANCEINFO_SOURCE, FRANCETV_SOURCE } from '../../../../common/theme/svg';
import { getSizeFactor } from '../../../../common/utils/tools';
import { connect, withBreakPoints } from '../../../hoc';
import { SOURCE_BUTTON_SIZE, SOURCE_BUTTON_STYLE } from './styles';

const resolveLogo = (source) => (source === 'franceinfo' ? FRANCEINFO_SOURCE : FRANCETV_SOURCE);

function SourceButton({
  extraSmall,
  small,
  medium,
  large,
  originUrl,
  origin,
  isAd
}) {
  return originUrl && !isAd
    && !small && !medium
    && (
      <div
        role="presentation"
        style={SOURCE_BUTTON_STYLE}
        onClick={(e) => { e.stopPropagation(); window.open(originUrl); }}
      >
        <SVGCreator
          paths={resolveLogo(origin)}
          width={SOURCE_BUTTON_SIZE.width * getSizeFactor({ extraSmall, large })}
          height={SOURCE_BUTTON_SIZE.height * getSizeFactor({ extraSmall, large })}
        />
      </div>
    );
}

const selector = ({ ui: { originUrl, origin }, media: { isAd } }) => ({ originUrl, origin, isAd });
export default withBreakPoints(connect(selector)(SourceButton));
